import { FLOW_STEPS } from '@/constants/flow-steps'
const { ELIGIBLE_STEP } = FLOW_STEPS.ENROLL_CARD
const { PPDC_UPSELL_XO } = FLOW_STEPS.XO_PPDC

export const BUTTON_TYPE = {
  PRIMARY: 'PRIMARY',
}

export const IMAGE_TYPE = {
  URL: 'URL',
}

export const INFO_TYPE = {
  HEADER: 'HEADER',
  PRIMARY: 'PRIMARY',
}

export const TEXT_TYPES = {
  HEADING: 'HEADING',
  HEADING_PRO: 'HEADING_PRO',
  BODY: 'BODY',
  CAPTION: 'CAPTION',
}

// export const XO_PPDC_STEP = 'XO_PPDC_STEP'

export const ENROLLMENT_TOUCHPOINTS = {
  [ELIGIBLE_STEP]: [
    'consumerweb_ucs_enrollment_image',
    'consumerweb_ucs_enrollment_info',
    'consumerweb_ucs_enrollment_button',
  ],
  [PPDC_UPSELL_XO]: [
    'ppdc_upsell_at_XO',
  ],
}

export const ENROLLMENT_TOUCHPOINTS_GB = {
  [ELIGIBLE_STEP]: [
    'ppdc_landing_screen'
  ],
}

export const CARD_BASIC_WIDGET_OPTIONS = {
  CARD_SHOW_ENABLED: {
    TRUE: 'TRUE',
    FALSE: 'FALSE',
  },
  CARD_SHOW_OVERRIDE: {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
  },
}
